import { useQuery } from "@tanstack/react-query";
import { FetchProfileQueryParams, fetchProfiles, FetchProfilesResponse } from "PFCore/services/profile";
import { QueryOptions } from "PFTypes/request_options";

import { profilesKeys } from "./query_keys";

export const useProfiles = (
  params: FetchProfileQueryParams,
  options: QueryOptions<FetchProfilesResponse> = {}
) =>
  useQuery<FetchProfilesResponse>({
    queryKey: profilesKeys.all(params),
    queryFn: () => fetchProfiles(params),
    ...options
  });
